import { observable, keys } from "mobx"

const cachedObservableObjectDict: any = {};

export const cachedObservableObject = (id: string, sourceObject: any) => {
  if (!id) return observable.object(sourceObject);

  let oo: any = cachedObservableObjectDict[id];
  if (oo === undefined) {
    oo = observable.object(sourceObject);
    cachedObservableObjectDict[id] = oo;
  }
  else {
    const sourceKeys = Object.keys(sourceObject);
    const ooKeys = keys(oo);

    // remove keys that no longer in source objects
    ooKeys.forEach((key) => {
      if (sourceKeys.indexOf(String(key)) === -1) {
        delete oo[key];
      }
    });

    sourceKeys.forEach((key: string) => {
      if (oo[key] !== sourceObject[key]) {
        oo[key] = sourceObject[key];
      }
    });
  }

  return oo;
}

const cachedObservableArrayDict: any = {};

export const cachedObservableObjectArray = (id: string, idGetter: (sourceObject: any) => string, sourceObjects: any[]) => {
  if (!id) return observable.array(sourceObjects);

  const results: any[] = sourceObjects.map((sourceObject: any) => {
    const id = idGetter(sourceObject);
    return cachedObservableObject(id, sourceObject);
  });

  let oo: any = cachedObservableArrayDict[id];
  if (oo === undefined) {
    oo = observable.array(results);
    cachedObservableArrayDict[id] = oo;
  }
  else {
    oo.replace(results);
  }

  return oo;
}